import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { GamlAttestationService } from '../../../services/gaml-attestation/gaml-attestation.service';
import { NotificationComponent } from '../../../components/notification/notification.component';
import { NotificationHeaderComponent } from '../../../components/notification/notification-header.component';
import { InlineIconWrapperComponent } from '../../../features/inline-icon-wrapper/inline-icon-wrapper.component';
import { DatePipe } from '../../../pipes/date.pipe';
import { HrefDirective } from '../../../directives/href/href.directive';
import { GamlAttestationAnalytics } from '../../../services/gaml-attestation/gaml-attestation.analytics';
import { IfFeatureDirective } from '../../if-feature/if-feature.directive';
import { IfNoFeatureDirective } from '../../if-feature/if-no-feature.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationComponent,
    NotificationHeaderComponent,
    InlineIconWrapperComponent,
    TranslatePipe,
    TranslateDirective,
    DatePipe,
    HrefDirective,
    IfFeatureDirective,
    IfNoFeatureDirective
  ],
  selector: 'td-wb-gaml-global-notification-banner',
  templateUrl: 'gaml-global-notification-banner.component.html',
  styleUrls: ['gaml-global-notification-banner.component.scss']
})
export class GamlGlobalNotificationBannerComponent {
  gamlDueDate: Date;
  bannerAnalyticsEventLinkName: string;

  constructor(private gamlAttestationService: GamlAttestationService,
              private gamlAttestationAnalytics: GamlAttestationAnalytics) {
    this.gamlDueDate = this.gamlAttestationService.gamlStatusData?.dueDate;
    this.bannerAnalyticsEventLinkName = this.gamlAttestationAnalytics.GAML_ATTESTATION_BANNER_EVENT.link.name;
  }
}
